import { Component, EventEmitter, Input, Output } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd";

@Component({
  selector: "hd-tip",
  templateUrl: "./hd-tip.component.html",
  styleUrls: ["./hd-tip.component.less"],
})
export class HdTipComponent {
  @Input() showIcon: boolean = true;
  @Input() fontSize: number;
  @Input() title: string;
  /** 是否在右侧展示展开/收起，默认关闭 */
  @Input() @InputBoolean() showCollapse: boolean = false;
  /** 当前是否展开（父组件可用 [(expanded)] 控制其它区块显隐） */
  @Input() @InputBoolean() expanded: boolean = true;
  @Output() expandedChange = new EventEmitter<boolean>();

  /** 展开（供父组件 ViewChild 调用） */
  expand(): void {
    this.setExpanded(true);
  }

  /** 收起（供父组件 ViewChild 调用） */
  collapse(): void {
    this.setExpanded(false);
  }

  /** 切换展开/收起（供父组件 ViewChild 或点击触发） */
  toggle(): void {
    this.setExpanded(!this.expanded);
  }

  private setExpanded(value: boolean): void {
    if (this.expanded === value) {
      return;
    }
    this.expanded = value;
    this.expandedChange.emit(this.expanded);
  }
}
